import { useSelector } from "react-redux";
import SplashHeader from "../common/header/SplashHeader";
import SEO from "../common/SEO";
import SplashBanner from "../component/banner/SplashBanner";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import useCorporate from "../hooks/useCorporate";
import { useEffect, useState } from "react";
import BlogGridOne from "../component/blog/BlogGridOne";
import BlogSidebar from "../component/blog/BlogSidebar";
import CardsLists from "../component/CardsLists";
import FooterOne from "../common/footer/FooterOne";
import SplashFooter from "../common/footer/SplashFooter";
import BannerOne from "../component/banner/BannerOne";
import BannerFour from "../component/banner/BannerFour";
import BannerFive from "../component/banner/BannerFive";
import HeaderOne from "../common/header/HeaderOne";
import { t } from "i18next";
import { media_url } from "../hooks/useBlog";

const OnlineProcedures = ({}) => {
  const { currentCustomer, procedures, departments, proceduresLoaded } =
    useSelector((state) => state.store);
  const { loadProceduresList } = useCorporate();
  const [viewState, setViewState] = useState({
    filteredProcedures: procedures,
    availableDepartments: [],
    selectedDepartment: null,
  });

  const handleSearch = (s) => {
    const filtered = procedures.filter(
      (procedure) =>
        procedure.name.toLowerCase().includes(s.toLowerCase()) ||
        procedure.description.toLowerCase().includes(s.toLowerCase()) ||
        procedure.department?.name.toLowerCase().includes(s.toLowerCase()) ||
        procedure.product?.calc_price.toString().includes(s)
    );
    setViewState((prevState) => ({
      ...prevState,
      filteredProcedures: filtered,
    }));
  };

  useEffect(() => {
    if (currentCustomer) {
      console.log("Current customer set, loading procedures.");
      loadProceduresList();
    }
  }, [currentCustomer]);

  useEffect(() => {
    if (proceduresLoaded) {
      setViewState((prevState) => ({
        ...prevState,
        filteredProcedures: procedures,
      }));
    }
  }, [proceduresLoaded]);

  useEffect(() => {
    if (departments.length > 0) {
      var activeDepartments = departments.filter((d) => d.is_active);
      // only departments that are in procedures.department.id
      var filteredDepartments = activeDepartments.filter((d) =>
        procedures.some((p) => p.department?.id === d.id)
      );
      setViewState((prevState) => ({
        ...prevState,
        availableDepartments: filteredDepartments,
      }));
    }
  }, [departments, procedures]);

  useEffect(() => {
    if (viewState.selectedDepartment) {
      const filtered = procedures.filter(
        (procedure) =>
          procedure.department?.id === viewState.selectedDepartment.id
      );
      setViewState((prevState) => ({
        ...prevState,
        filteredProcedures: filtered,
      }));
    }
  }, [viewState.selectedDepartment]);

  if (!proceduresLoaded) {
    return <div>Cargando trámites...</div>;
  }

  return (
    <>
      <SEO
        title={t("Trámites en línea")}
        description={t(
          `Accede a todos los trámites en línea de {{customerName}} de manera rápida y sencilla.`,
          { customerName: currentCustomer.name }
        )}
        keywords={
          "Alcaldía, Trámites, solicitudes, Gobierno electrónico, ciudad digital, gestión ciudad, En línea, Online, "
        }
        image={media_url(currentCustomer.logo)}

      />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BannerFour
          title={`Trámites en Línea `}
          subtitle={`Accede a todos los trámites en línea de ${currentCustomer.name} de manera rápida y sencilla.`}
          image={
            process.env.PUBLIC_URL +
            `/images/gestionciudad/online_procedures.jpg`
          }
        />
        <div className="container ">
          <div
            className="section-heading heading-left"
            style={{
              marginTop: "140px",
            }}
          >
            <div className="row ">
              <div className="col-xl-12">
                <p>
                  Con nuestra gestión digital facilitamos el acceso a los
                  trámites en línea las 24 horas.
                </p>
                <p>{currentCustomer.name} está aquí para servirte.</p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="section  "
          style={{
            padding: "10px 0 !important",
          }}
        >
          <div className="container">
            <div className="section-heading heading-left">
              <div className="row ">
                <div className="col-xl-6 col-lg-6 col-sm-12">
                  <div className="form-group" style={{ marginBottom: "20px" }}>
                    <label
                      htmlFor="search"
                      style={{ marginBottom: "10px" }}
                      className="form-label label"
                    >
                      Buscar
                    </label>
                    <input
                      type="text"
                      id="search"
                      className="form-control"
                      placeholder="Buscar..."
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-sm-12">
                  <div className="form-group">
                    <label
                      htmlFor="department"
                      style={{ marginBottom: "10px" }}
                      className="form-label label"
                    >
                      Filtra por departamento:
                    </label>
                    <select
                      id="department"
                      value={viewState.selectedDepartment?.id || ""}
                      onChange={(e) => {
                        const selectedDepartment = departments.find(
                          (department) =>
                            department.id === parseInt(e.target.value)
                        );
                        console.log(
                          departments,
                          e.target.value,
                          selectedDepartment
                        );
                        setViewState((prevState) => ({
                          ...prevState,
                          selectedDepartment,
                          filteredProcedures: selectedDepartment
                            ? procedures.filter(
                                (procedure) =>
                                  procedure.departmentId ===
                                  selectedDepartment.id
                              )
                            : procedures,
                        }));
                      }}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    >
                      <option value="" disabled defaultValue>
                        Selecciona un departamento
                      </option>
                      {viewState.availableDepartments
                        .filter((d) => d.is_active)
                        .map((department) => (
                          <option key={department.id} value={department.id}>
                            {department.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {viewState.filteredProcedures.length > 0 && (
          <CardsLists
            grid
            title={"Trámites disponibles"}
            data={viewState.filteredProcedures.map((p) => {
              return {
                id: p.id,
                title: p.name,
                subtitle: p.name,
                href: `/${currentCustomer.shortname}/corporate/procedure/preview/${p.id}`,
                para: (
                  <div class="">
                    <div className="row">
                      <div className="col-12">
                        {p.department.name}
                        {/* show tooltip and icon with number of requirments */}
                        <span
                          className="tooltip-icon"
                          style={{ marginLeft: "10px" }}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/icon/icon-31.png"
                            }
                            alt="Thumb"
                            style={{
                              width: "32px",
                              height: "32px",
                              marginRight: "5px",
                            }}
                          />
                          <span className="tooltiptext">
                            {p.requirements?.length} requisitos
                          </span>
                        </span>
                      </div>
                      {p.product && (
                        <div
                          className="col-12 text-end mt-3"
                          style={{
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                          }}
                        >
                          <span
                            className="product-name"
                            style={{
                              marginLeft: "15px",
                              fontWeight: "bold",
                              color: "#059d30ff",
                              border: "1px solid #ccc",
                              padding: "5px",
                              borderRadius: "5px",
                              backgroundColor: "#e6f7e6",
                            }}
                          >
                            {p.product.calc_price.toLocaleString("es-VE", {
                              style: "currency",
                              currency: "VES",
                            })}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ),
              };
            })}
          />
        )}
        <SplashFooter />
      </main>
    </>
  );
};

export default OnlineProcedures;
